// Adjust this to change how many employee rows print on one Bank Letter
// page before a new page starts - the new page repeats the full letter
// (address, salutation, body paragraph) with its own subtotal for just
// that page's rows, rather than letting the table silently overflow.
export const bankLetterConfig = {
  rowsPerPage: 20,
}
